import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';
import styles from './ShareholdersView.module.scss';
import { Container, Title } from 'common/components/Layout/Layout';
import messages from './ShareholdersView.intl';
import Shareholders from '../Home/Sections/Management/Components/Shareholders/Shareholders';
import ReturnToInvestors from '../../common/components/ReturnToInvestors/ReturnToInvestors';
@injectIntl
@observer
export default class ShareholdersView extends Component {
  render() {
    if (!ContentStore.isLoaded) {
      return null;
    }

    return (
      <div>
        <Container>
          <Title title={this.props.intl.formatMessage(messages.title)} />
        </Container>
        <Container>
          <ReturnToInvestors />
        </Container>
        <Container>
          <div className={styles.ShareholdersContainer}>
            <Shareholders />
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Shareholders/ShareholdersView.js